export default __webpack_public_path__ + "static/media/wc-logo.b0391bff.svg";